import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

interface Props {
  children: ReactNode
}

interface SessionDurationContext {
  readDurationSeconds: () => number
  reset: () => void
}

const context = createContext<SessionDurationContext>({
  readDurationSeconds: () => 0,
  reset: () => undefined,
})

const { Provider } = context

const useSessionDuration = (): SessionDurationContext => useContext(context)

const SessionDurationProvider = ({ children }: Props) => {
  const [startTime, setStartTime] = useState<number>(Date.now())
  const readDurationSeconds = useCallback(() => Math.round((Date.now() - startTime) / 1000), [startTime])
  const reset = useCallback(() => setStartTime(Date.now()), [setStartTime])
  const contextValue = { readDurationSeconds, reset }

  return <Provider value={contextValue}>{children}</Provider>
}

export { SessionDurationProvider, useSessionDuration }
